import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { formatTimestampInMap } from '../../../utils';

const CheckLists = ({
    list,
    type,
    isApprove,
    approveDocumentDetails,
    handleAccepted,
    accepted,
    showApprove = false
}) => {

    const isPersonal = type === "personalDocument";

    const checkList = isPersonal
        ? list?.personal_document_type_check_items
        : list?.document_type_check_items;

    const listDescription = isPersonal
        ? list?.personal_document_type_check_list_description
        : list?.document_type_check_list_description;

    const documentCheckAt = isPersonal
        ? approveDocumentDetails?.ftm_personal_document_check_check_at
        : approveDocumentDetails?.document_check_check_at;

    const approvedBy = approveDocumentDetails?.admin_user?.admin_full_name;

    const approvedText = (
        <b>{`${approvedBy} approved this document at ${formatTimestampInMap(documentCheckAt)}.`}</b>
    );

    const renderChecklistItem = (item, index) => {
        const label = isPersonal
            ? item.personal_document_type_check_item_label
            : item.document_type_check_item_label;

        return (
            <div className="d-flex justify-content-lg-start justify-content-center px-2" key={index}>
                <i className="material-icons my-auto text-xs">circle</i>
                <span className="text-md ps-3">{label}</span>
            </div>
        );
    };

    return (
        <div className="card mt-4" style={{ boxShadow: "unset" }}>
            <div className="card-body py-2 mt-3">
                <h5 className="font-weight-bold text-md mb-1">
                    {listDescription}
                </h5>

                {checkList?.map(renderChecklistItem)}

                <div className="mt-2">
                    {(showApprove || isApprove)
                        ? approvedText
                        : (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={accepted}
                                        onChange={(e) => handleAccepted(e.target.checked)}
                                        color="success"
                                        size="small"
                                    />
                                }
                                label={<b className="text-md">I have reviewed every item on the checklist. 963</b>}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default CheckLists;